(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').component('apMultiSelectListItem', {
        templateUrl: '/core-ui/component-views/ap-multi-select-fa-button.html',
        bindings: {
            collection: '<',
            ngDisabled: '&',
        },
        require: {
            ngModelCtrl: 'ngModel',
        },
        controller: [
            '$element',
            'ApMultiSelectButton',
            'MultiSelectListItemModal',
            MultiSelectGenericComponent,
        ],
        controllerAs: 'vm',
    });

    function MultiSelectGenericComponent(
        $element,
        ApMultiSelectButton,
        MultiSelectListItemModal
    ) {
        var vm = this;

        ApMultiSelectButton.init(vm, openModal, formatter, null, $element.find('button'));

        function openModal(selectedItems) {
            return MultiSelectListItemModal.openModal(vm.collection, selectedItems, formatter, null);
        }

        function formatter(listItem) {
            return listItem.Description || listItem.Name;
        }
    }

})(window.angular);